<template>
  <div class="app-container">
    统计
    <!-- <list ref="list"></list> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/bm/analysis/list";

export default {
  name: "analysis",
  // mixins: [curdMixins],
  components: {
    list,
  },
  methods: {},
};
</script>